export const taboola = (): void => {
  // COMMENT OUT IF NEEDED TO TEST IN DEVELOPMENT
  if (process.env.NODE_ENV !== 'development') {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.innerHTML = `
      window._tfa = window._tfa || [];
      !function (t, f, a, x) {
            if (!document.getElementById(x)) {
                t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);
            }
      }(document.createElement('script'),
      document.getElementsByTagName('script')[0],
      '//cdn.taboola.com/libtrc/unip/1859687/tfa.js',
      'tb_tfa_script');
    `

    document.head.appendChild(script)
  }
}
